import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Home() {
  const { t } = useTranslation();
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section" data-aos="fade-up">
        <div className="hero-overlay">
          <h1 className="hero-title">{t("home.hero.title")}</h1>
          <p className="hero-description">{t("home.hero.description")}</p>
        </div>
      </section>

      {/* Wood Trading Section */}
      <section className="trading-section" data-aos="fade-up">
        <h2 className="section-title">{t("home.trading.title")}</h2>
        
        <p className="trading-text" data-aos="fade-up">{t("home.trading.paragraph1")}</p>
        
        <div className="trading-images" data-aos="fade-up">
          <img src="/images/trading-img1.jpeg" alt="Wood import" className="trading-image" data-aos="zoom-in" />
          <img src="/images/trading-img2.jpeg" alt="Timber warehouse" className="trading-image" data-aos="zoom-in" data-aos-delay="100" />
        </div>

        <p className="trading-text" data-aos="fade-up">{t("home.trading.paragraph2")}</p>
        
        <div className="trading-images" data-aos="fade-up">
          <img src="/images/trading-img3.jpeg" alt="Quality control" className="trading-image" data-aos="zoom-in" />
          <img src="/images/trading-img4.jpeg" alt="Lumber products" className="trading-image" data-aos="zoom-in" data-aos-delay="100" />
        </div>

        <p className="trading-text" data-aos="fade-up">{t("home.trading.paragraph3")}</p>
        
        <div className="trading-images" data-aos="fade-up">
          <img src="/images/trading-img5.jpeg" alt="Delivery service" className="trading-image" data-aos="zoom-in" />
          <img src="/images/trading-img6.jpeg" alt="Construction site" className="trading-image" data-aos="zoom-in" data-aos-delay="100" />
        </div>
      </section>

      {/* News and Blog Section */}
      <section className="news-section" data-aos="fade-up">
        <h2 className="section-title">{t("home.news.title")}</h2>
        <div className="news-grid">
          <div className="news-card" data-aos="fade-up" data-aos-delay="100">
            <h3>{t("home.news.article1.title")}</h3>
            <p>{t("home.news.article1.description")}</p>
            <Link to="/article/softwood-market" className="read-more-btn">{t("home.news.readMore")}</Link>
          </div>
          <div className="news-card" data-aos="fade-up" data-aos-delay="200">
            <h3>{t("home.news.article2.title")}</h3>
            <p>{t("home.news.article2.description")}</p>
            <Link to="/article/superwood-invention" className="read-more-btn">{t("home.news.readMore")}</Link>
          </div>
          <div className="news-card" data-aos="fade-up" data-aos-delay="300">
            <h3>{t("home.news.article3.title")}</h3>
            <p>{t("home.news.article3.description")}</p>
            <Link to="/article/arkansas-timber-center" className="read-more-btn">{t("home.news.readMore")}</Link>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section" data-aos="fade-up">
        <h2 className="section-title">{t("home.services.title")}</h2>
        <div className="services-grid">
          <div className="service-card" data-aos="fade-right">
            <div className="service-icon">📦</div>
            <h3>{t("home.services.service1.title")}</h3>
            <p>{t("home.services.service1.description")}</p>
          </div>
          <div className="service-card" data-aos="fade-up">
            <div className="service-icon">🛍️</div>
            <h3>{t("home.services.service2.title")}</h3>
            <p>{t("home.services.service2.description")}</p>
          </div>
          <div className="service-card" data-aos="fade-left">
            <div className="service-icon">🚚</div>
            <h3>{t("home.services.service3.title")}</h3>
            <p>{t("home.services.service3.description")}</p>
          </div>
          <div className="service-card" data-aos="fade-up">
            <div className="service-icon">💼</div>
            <h3>{t("home.services.service4.title")}</h3>
            <p>{t("home.services.service4.description")}</p>
          </div>
        </div>
      </section>

      {/* Who Are We Section */}
      <section className="who-we-are-section" data-aos="fade-up">
        <h2 className="section-title">{t("home.whoWeAre.title")}</h2>
        <p className="who-we-are-text">{t("home.whoWeAre.description")}</p>
      </section>

      {/* Achievements Section */}
      <section className="achievements-section" data-aos="fade-up">
        <h2 className="section-title">{t("home.achievements.title")}</h2>
        <div className="achievements-grid">
          <div className="achievement-card" data-aos="zoom-in">
            <div className="achievement-number">95%</div>
            <p>{t("home.achievements.customerSatisfaction")}</p>
          </div>
          <div className="achievement-card" data-aos="zoom-in" data-aos-delay="100">
            <div className="achievement-number">85%</div>
            <p>{t("home.achievements.salesIncrease")}</p>
          </div>
          <div className="achievement-card" data-aos="zoom-in" data-aos-delay="200">
            <div className="achievement-number">90%</div>
            <p>{t("home.achievements.efficiencyImprovement")}</p>
          </div>
          <div className="achievement-card" data-aos="zoom-in" data-aos-delay="300">
            <div className="achievement-number">80%</div>
            <p>{t("home.achievements.revenueIncrease")}</p>
          </div>
        </div>
      </section>

      {/* Goals Section */}
      <section className="goals-section" data-aos="fade-up">
        <h2 className="section-title">{t("home.goals.title")}</h2>
        <div className="goals-grid">
          <div className="goal-card" data-aos="fade-right">
            <h3>{t("home.goals.goal1.title")}</h3>
            <p>{t("home.goals.goal1.description")}</p>
          </div>
          <div className="goal-card" data-aos="fade-up">
            <h3>{t("home.goals.goal2.title")}</h3>
            <p>{t("home.goals.goal2.description")}</p>
          </div>
          <div className="goal-card" data-aos="fade-left">
            <h3>{t("home.goals.goal3.title")}</h3>
            <p>{t("home.goals.goal3.description")}</p>
          </div>
          <div className="goal-card" data-aos="fade-up">
            <h3>{t("home.goals.goal4.title")}</h3>
            <p>{t("home.goals.goal4.description")}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
